/**
 * Cart Subscribe & Save toggle (drawer + cart page).
 *
 * Lives in an asset (not inline in cart-products.liquid) because that snippet only
 * renders when the cart has items: with an empty cart at page load the inline script
 * never ran, and the first add injects the drawer HTML via morph where injected
 * script tags do not execute — so the subscribe checkbox was dead until a reload.
 * Loaded unconditionally from header-actions.liquid next to component-cart-items.js.
 */
(function () {
  if (window.__cartSubUpsellInit) return;
  window.__cartSubUpsellInit = true;

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function emitCartUpdate(cart, sections) {
    var evt = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'cart-subscription-upsell',
        data: {
          itemCount: (cart && cart.item_count) || 0,
          source: 'cart-subscription-upsell',
          sections: sections,
        },
      },
    });
    document.dispatchEvent(evt);
  }

  function dispatchCartUpdate(cart) {
    // Match main: emit ONE cart:update with the sections bundled in the /cart/change
    // response and let cart-items-component do the single re-render. The extra
    // "?sections=" re-fetch + manual morph + inline-script re-run that used to live here
    // double-morphs the drawer (the second morph lands late behind a dynamic import) and
    // tramples the Rebuy widget's DOM/listeners inside cart-items-component — that's what
    // froze Rebuy and blanked the drawer body on mobile. Subscribe toggles only happen on
    // a populated cart, so the theme's normal morph is enough (proven on main).
    emitCartUpdate(cart, cart && cart.sections);
  }

  function changeSellingPlan(lineIndex, quantity, sellingPlanId, widget) {
    widget.classList.add('cart-sub-upsell--loading');

    var sectionIds = getCartSectionIds();
    var itemKey = widget.dataset.itemKey;

    // cache: 'no-store' — Safari/WebKit can serve a stale cached /cart.js here, which made
    // the toggle act on old line indexes / old Loop txn ids and skip the discount on iPhone.
    fetch(window.Theme?.routes?.cart_url || '/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        // Resolve the line by item key (line indexes go stale after morphs/Rebuy adds)
        var lineIdx = -1;
        if (itemKey && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === itemKey) {
              lineIdx = i;
              break;
            }
          }
        }
        if (lineIdx === -1) lineIdx = lineIndex - 1;
        lineIndex = lineIdx + 1;

        var item = cart.items && cart.items[lineIdx];
        if (item) quantity = item.quantity;
        var loopCart = window.LoopBundleCart;

        if (
          loopCart &&
          item &&
          loopCart.isLoopBundleItem(item) &&
          loopCart.getLoopMetaFromItem(item).presetProductId
        ) {
          return loopCart
            .syncLoopBundleSellingPlan({
              shopDomain: loopCart.getShopDomain(),
              cart: cart,
              triggerLineIndex: lineIndex,
              sellingPlanId: sellingPlanId || '',
              sectionIds: sectionIds,
            })
            .then(function (updatedCart) {
              return updatedCart || cart;
            });
        }

        var body = {
          line: lineIndex,
          quantity: quantity,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        };

        if (sellingPlanId !== undefined && sellingPlanId !== null && sellingPlanId !== '') {
          body.selling_plan = sellingPlanId;
        } else {
          body.selling_plan = '';
        }

        return fetch(window.Theme?.routes?.cart_change_url || '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        if (!cart || cart.errors) {
          console.error('[CartSubUpsell]', cart?.errors || cart);
          widget.classList.remove('cart-sub-upsell--loading');
          if (cart?.description) alert(cart.description);
          return;
        }
        if (cart.status) {
          console.error('[CartSubUpsell]', cart);
          widget.classList.remove('cart-sub-upsell--loading');
          alert(cart.description || cart.message || 'Could not update subscription');
          return;
        }

        dispatchCartUpdate(cart);
      })
      .catch(function (err) {
        console.error('[CartSubUpsell]', err);
        alert(err.message || 'Could not update subscription');
      })
      .finally(function () {
        widget.classList.remove('cart-sub-upsell--loading');
      });
  }

  document.addEventListener('change', function (e) {
    var checkbox = e.target.closest('.cart-sub-upsell__checkbox');
    if (checkbox) {
      var widget = checkbox.closest('.cart-sub-upsell');
      var lineIndex = parseInt(widget.dataset.lineIndex, 10);
      var quantity = parseInt(widget.dataset.quantity, 10);

      if (checkbox.checked) {
        var planId = parseInt(checkbox.dataset.firstPlanId, 10);
        changeSellingPlan(lineIndex, quantity, planId, widget);
      } else {
        changeSellingPlan(lineIndex, quantity, '', widget);
      }
      return;
    }

    var select = e.target.closest('.cart-sub-upsell__select');
    if (select) {
      var widget = select.closest('.cart-sub-upsell');
      var lineIndex = parseInt(widget.dataset.lineIndex, 10);
      var quantity = parseInt(widget.dataset.quantity, 10);
      var sellingPlanId = select.value === '' ? '' : parseInt(select.value, 10);
      changeSellingPlan(lineIndex, quantity, sellingPlanId, widget);
    }
  });

  // When a cart item row animates out, also animate out its subscription upsell row.
  // Observes document.body because this script loads even when the cart is empty —
  // the cart table doesn't exist yet at load time (the first add injects it via morph).
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        var row = mutation.target;
        if (row.classList.contains('cart-items__table-row') && row.classList.contains('removing')) {
          var itemKey = row.dataset.key;
          if (itemKey) {
            var upsellRow = document.querySelector('.cart-sub-upsell__row[data-key="' + itemKey + '"]');
            if (upsellRow) {
              upsellRow.style.setProperty('--row-height', upsellRow.clientHeight + 'px');
              upsellRow.classList.add('removing');
              upsellRow.addEventListener(
                'animationend',
                function () {
                  upsellRow.remove();
                },
                { once: true },
              );
            }
          }
        }
      }
    });
  });

  observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });
})();
